export default {
    subtitle: "Become a sponsor",
    aboutUs: "About us",
}